import { fieldPropTypes } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import { baseInput, getBorderColor } from './Styles';
import Input from '../../components/Form/Input';

const StyledInput = styled('input')`
  ${baseInput};
  border-color: ${props => getBorderColor(props)};
`;

function InputText(props) {
  return (
    <Input {...props}>
      <StyledInput
        {...props.input}
        {...props.meta}
        placeholder={props.placeholder}
        type={props.type}
      />
    </Input>
  );
}

InputText.propTypes = {
  ...fieldPropTypes,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
};

InputText.defaultProps = {
  label: '',
  placeholder: '',
  type: 'text',
};

export default InputText;



// WEBPACK FOOTER //
// ./src/components/Form/InputText.js